import React from "react";
import { Mui } from "@osu/react-ui";
import { useApplicantDetailsState } from "../hooks/useApplicantDetailsState";

const classes = {
    width100: {
      width: "100%",
    },
    listItemText: {
      flexBasis: "50%",
      display: "flex",
      alignItems: "center",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      paddingBottom: '2rem',
    },
    listItemLast: {
      flexBasis: "50%",
      display: "flex",
      alignItems: "center",
      paddingBottom: '2rem',
    },
    dataList: {
      flexDirection: "row",
      flexWrap: "wrap",
    },
};

const HighSchool = () => {
  const { data } = useApplicantDetailsState();
  const hsData = data?.details.highSchool ?? {};

  return (
    <>
      <Mui.Box sx={classes.width100}>
        <Mui.Typography variant="subtitle2" component="h3" tabindex="0">{hsData?.highSchoolName}</Mui.Typography>
        <Mui.List sx={{ display: "flex", ...classes.dataList, ...classes.width100 }} component="dl">
           
            <Field clasz={classes.listItemText} label="Location" value={hsData.highSchoolLocation} />  
            <Field clasz={classes.listItemText} label="Graduation Date" value={hsData.highSchoolGraduationDate} />
            <Field clasz={classes.listItemText} label="Best Test" value={hsData.bestTest?.score} />
            {/* <Field clasz={classes.listItemText} label="Latest Test" value={hsData.bestTest?.comments} /> */}
            <Field clasz={classes.listItemText} label="HighSchool GPA" value={hsData.highSchoolGPA} />
            <Field clasz={classes.listItemText} label="Class Rank/Type" value={hsData.classRankPercentileType} />
            <Field clasz={classes.listItemText} label="Class Standing/Size" value={hsData.classStandingSize} />
       
        </Mui.List>
      </Mui.Box>
    </>
  );
};

function Field({ label, value, clasz }) {
    return (
        <Mui.ListItemText primary={label} secondary={value} sx={clasz} tabindex="0"
        
            primaryTypographyProps={{
                component: "dt",
                sx: { marginRight: 2 },
                variant: "subtitle2",
            }}
            
            secondaryTypographyProps={{
                component: "dd",
                variant: "body2",
                color: "textPrimary",
            }}
        />
    );
}

export default HighSchool;